import { Component } from "@angular/core";
import { PermissionsFacade } from "@webapp/permissions/services/permissions-facade.service";
import { Observable } from "rxjs";
@Component({
  selector: "gh-example-permissions-component",
  templateUrl: "example-permissions.component.html",
  styleUrls: [],
})
export class ExamplePermissionsComponent {
  public hasPermission$: Observable<boolean>;
  public constructor(private permissionsFacade: PermissionsFacade) {
    this.hasPermission$ = this.permissionsFacade.hasPermission$("ManageAccountNotifications");
  }
}
